<template>
  <div class="robot-box">
    <img src="https://files.wondercv.com/pc/jobscan/robot-gif.png" width="130" class="robot-img">
    <p class="robot-name">求职小帮手</p>
    <div class="content-box">
      <img :src="typeStr == 'jobRecommend' && !isShowThank ? 'https://files.wondercv.com/PC/cvs/career_planning.png' : `https://files.wondercv.com/pc/jobscan/${isShowThank ? 'thank' : 'content'}.png`" class="content-img" :class="[showContent && showRobotContent ? 'show' : '']">
      <div class="robot-btn-ok" @click="handleCLickFeedbackBtn(true)"></div>
      <div class="robot-btn-no" @click="handleCLickFeedbackBtn(false)"></div>
    </div>
    <div class="accurate-no" v-show="isShowAccurate" :style="{height: '321px', top: '-190px'}">
      <p class="title">{{isAccurate ? '你觉得哪项结果有待提升？' : '你觉得哪项结果不准？'}}</p>
      <div class="modules">
        <div class="module-item" v-for="(item, index) in noList[typeStr].arrLabel" :class="[activeList.includes(index) ? 'active' : '']" :key="item" @click="handleClickAddActiveList(index)">{{item}}</div>
      </div>
      <div style="flex: 1">
        <textarea class="iconfont" name="" placeholder="给我们提点建议" v-model="feedback"></textarea>
      </div>
      <div class="sub-btn-box">
        <div class="sub-btn" @click="handleClickSub">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../../api";
export default {
  name:'robot',
  props:{
    typeStr: {
      type: String,
      default: 'jobRecommend'
    },
    delayed: {
      type: Number,
      default: 1700
    },
    cv_token: {
      type: String,
      default: ''
    },
    showRobotContent: {
      type: Boolean,
      default: false
    } 
  },
  data(){
   // ['profession_recommendation', 'user_comparison', 'profession_comparison']
   return {
      noList:{
        jobRecommend: {
          arrLabel: ['本命职位', '可胜任职位', '可尝试职位', '推荐用户'],
          index: 0
        },
        userContrast: {
          arrLabel: ['能力雷达图','过往经历','简历分析','技能分析','竞争力分析','职位推荐'],
          index: 1
        },
        jobContrast: {
          arrLabel: ['职类等级','背景分析','匹配度分析','职位推荐'],
          index: 2
        },
      },
      activeList: [],
      isShowAccurate: false,
      isAccurate: false,  // 点击了有帮助还是没帮助
      feedback: '',
      isShowThank: false,
      showContent: false,  // 显示有帮助没帮助弹框
      showFeedbackOnce: ''  // 只反馈一次
   }
  },
  created(){
    // 只反馈一次  以token为key 以页面下标组成的数组为value
    this.showFeedbackOnce = JSON.parse(localStorage.getItem('showFeedbackOnce'))
    if(!this.showFeedbackOnce) {
      localStorage.setItem('showFeedbackOnce', '{}')
      this.showFeedbackOnce = {}
    } 
    else if(!this.showFeedbackOnce[this.cv_token] || !(this.showFeedbackOnce[this.cv_token].includes(this.noList[this.typeStr].index))){  // 判断此份简历在哪几个页面反馈过
      setTimeout(()=>{
        this.showContent = true
      },this.delayed)
    }
  },
  methods:{
    handleClickSub(){
      if(this.feedback.length > 500) {
        this.$message.error('反馈字数不能超过500')
        return
      }
      this.isShowAccurate = false
      this.isShowThank = true
      let params = {
        cv_token: this.cv_token,
        correct: this.isAccurate,
        page: this.noList[this.typeStr].index,
        module_titles: this.noList[this.typeStr].arrLabel.filter((item,index) => this.activeList.includes(index)).join(','),
        feedback: this.feedback,
      }
      api.planning.feedback(params).then(res => {
        console.log(res);
        this.showContent = false
        // 每份简历每个页面只反馈一次
        if(!this.showFeedbackOnce[this.cv_token]){
          this.showFeedbackOnce[this.cv_token] = []
        }
        this.showFeedbackOnce[this.cv_token].push(this.noList[this.typeStr].index)
        localStorage.setItem('showFeedbackOnce', JSON.stringify(this.showFeedbackOnce))
      })
    },
    handleClickAddActiveList(index){
      if(this.activeList.includes(index)){
        this.activeList = this.activeList.filter(item => item !== index)
      }else{
        let set = new Set([...this.activeList, index])
        this.activeList = [...set]
      }
    },
    handleCLickFeedbackBtn(bool){
      this.isShowAccurate = true;
      this.isAccurate = bool;
    }
  }
}
</script>

<style scoped lang='scss'>
  .robot-box{
    position: fixed;
    right: 54px;
    bottom: 77px;
    z-index: 10;
    .robot-name{
      font-size: 14px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 14px;
      text-align: center;
      margin-top: -7px;
    }
    .robot-img{
      cursor: pointer;
      transform: scale(0.85);
    }
    &.hide{
     /*transform: translateX(500px);*/
      transition: all 0.7s linear;
    }
    .thank-img{
      position: absolute;
      right:64px;
      bottom: 0;
    }
    .accurate-no{
      width: 260px;
      background: #FFFFFF;
      border-radius: 12px;
      position: absolute;
      z-index: 5;
      top: -195px;
      right: 120px;
      padding: 20px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      .title{
        font-size: 16px;
        font-weight: 500;
        color: #404040;
        line-height: 22px;
        margin-bottom: 24px;
        text-align: center;
      }
      .modules{
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 14px;
        .module-item{
          padding: 2px 10px;
          border: 1px solid #ECECEC;
          color: #404040;
          border-radius: 13px;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          margin-right: 6px;
          margin-bottom: 10px;
          cursor: pointer;
          &:nth-of-type(2){
            margin-right: 0;
          }
          &.active{
            border: 1px solid #FF6644;
            color: #ff6644;
          }
        }
      }
      textarea{
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        resize: none;
        font-size: 14px;
      }
      .sub-btn-box{
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
        .sub-btn{
          cursor: pointer;
          width: 64px;
          height: 28px;
          background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
          border-radius: 16px;
          line-height: 28px;
          text-align: center;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
    }
    .content-box{
      overflow: hidden;
      position: absolute;
      right:120px;
      bottom: 0;
      z-index: 3;
      .robot-btn-ok{
        position: absolute;
        z-index: 9;
        /*background: red;*/
        width: 70px;
        height: 30px;
        bottom: 20px;
        left: 29px;
        cursor: pointer;
      }
      .robot-btn-no{
        position: absolute;
        z-index: 9;
        /*background: blue;*/
        width: 70px;
        height: 30px;
        bottom: 20px;
        left: 123px;
        cursor: pointer;
      }
      .content-img{
        transform: translate(100%);
        opacity: 0;
        width: 220px;
        height: 104px;
        position: relative;
        z-index: 1;
        transition: all .3s .5s linear;
        &.show{
          opacity: 1;
          transform: translate(0);
        }
      }

    }
  }
</style>
